import { z } from 'zod';

import { VALIDATION_MESSAGES } from '@/constants/constant';

export const loginFormSchema = z.object({
  email: z
    .string()
    .trim()
    .nonempty(VALIDATION_MESSAGES.email.required)
    .min(5, VALIDATION_MESSAGES.email.min)
    .max(100, VALIDATION_MESSAGES.email.max)
    .refine(
      (val) =>
        /^[a-zA-Z0-9](?!.*[-_.]{2})[a-zA-Z0-9._%+-]*@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,10}$/.test(
          val
        ),
      { message: VALIDATION_MESSAGES.email.invalid }
    ),

  password: z
    .string()
    .trim()
    .nonempty(VALIDATION_MESSAGES.password.required)
    .min(8, VALIDATION_MESSAGES.password.min)
    .max(20, VALIDATION_MESSAGES.password.max),
});

export type TLoginForm = z.infer<typeof loginFormSchema>;
